import { Injectable } from "@angular/core";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module";
@Injectable()
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    debugger;
    if (!value)
      return null
    let parts = value.split('/');
    return { day: +parts[0], month: +parts[1], year: +parts[2] } as NgbDateStruct

  }
  format(date: NgbDateStruct): string {
    return date ? ('0' + date.day).slice(-2) + "/" + ('0' + date.month).slice(-2) + "/" + ('0' + date.year).slice(-4) : null
  }
}
